import React from "react";
import PropTypes from "prop-types";
import type {ContainerFunctionComponent} from "react";
import {store, storePersistControl} from "./store";
import { Provider } from "react-redux";
import { PersistGate } from 'redux-persist/integration/react'


export const ReduxProvider: ContainerFunctionComponent = ({children}) => {
  return (
    <Provider store={store}>
      <PersistGate persistor={storePersistControl}>{children}</PersistGate>
    </Provider>
  );
}

ReduxProvider.propTypes = {
  children: PropTypes.node.isRequired,
}
